export default __webpack_public_path__ + "static/media/passport_batch2_web_resize.3e08fbc8.png";